import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {GRAY_LIGHT} from 'ui-library/Colors';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {OptionValue} from 'ui-library/menus/MenuConstants';

export interface CyclingSelectorProps {
  selector: React.ReactNode;
  disabled?: boolean;
  options: Array<OptionValue>;
  selectedOption: OptionValue;
  onChange: (option: OptionValue) => void;
}

function IconButton({
  onClick,
  icon,
  disabled,
}: {
  onClick: () => void;
  icon: BenchlingIconName;
  disabled?: boolean;
}): JSX.Element {
  return (
    <div
      className={css(styles.icon, disabled && styles.disabledIcon, !disabled && styles.iconEnabled)}
      onClick={disabled ? undefined : onClick}
    >
      <BenchlingIcon icon={icon} />
    </div>
  );
}

export default function CyclingSelector({
  selector,
  disabled,
  options,
  selectedOption,
  onChange,
}: CyclingSelectorProps): JSX.Element {
  const onCycleOption = (isAscending: boolean): void => {
    const currentIndex = options.indexOf(selectedOption);
    let newIndex = isAscending ? currentIndex + 1 : currentIndex - 1;
    if (newIndex < 0) {
      newIndex = options.length - 1;
    }
    if (newIndex >= options.length) {
      newIndex = 0;
    }
    onChange(options[newIndex]);
  };
  return (
    <div className={css(styles.container)}>
      <div className={css(styles.selector)}>{selector}</div>
      <IconButton
        disabled={disabled}
        onClick={() => {
          onCycleOption(false);
        }}
        icon="arrow-left"
      />
      <IconButton
        disabled={disabled}
        onClick={() => {
          onCycleOption(true);
        }}
        icon="arrow-right"
      />
    </div>
  );
}

const styles = StyleSheet.create({
  disabledIcon: {
    backgroundColor: Color.GRAY_100,
    cursor: 'not-allowed',
  },
  icon: {
    padding: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    width: 28,
  },
  iconEnabled: {
    backgroundColor: GRAY_LIGHT,
  },
  container: {
    alignItems: 'center',
    columnGap: '6px',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  },
  cycleOptions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  selector: {
    flex: 1,
  },
});
